<div class="row" *ngIf="SA">
  <ol class="breadcrumb backgroundclr">
    <li class="breadcrumb-item"><a href="/tenants-grid"><mat-icon aria-hidden="true">storefront</mat-icon><span>Tenants</span></a></li>
    <li class="breadcrumb-item active" aria-current="page">{{tenant?.tenantName}}</li>
  </ol>
</div>
 <div class="container landing-tabs">
    <div class="row">
        <div class="col tabs-column">
            <nav class="navbar navbar-light navbar-expand-md" aria-label="Business navigation">
                <div class="container-fluid">
                  <button data-toggle="collapse " class="navbar-toggler hidden-mobile" data-target="#navcol-1">
                        <span class="sr-only">
                            Toggle navigation
                        </span>
                        <span class="navbar-toggler-icon">

                        </span>
                  </button>

                    <div class="collapse navbar-collapse" id="navcol-1" >
                      <ul class="nav navbar-nav descriptionHeader" *ngIf="roleId < 3">
                        <li class="nav-item" routerLinkActive="active">
                          <a class="nav-link" routerLink="dashboard" (click)="clickedOnDashboard()"><mat-icon aria-hidden="true">dashboard</mat-icon><span>Dashboard</span></a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse">
                          <a class="nav-link" [routerLink]="['admin-bookings']" href="/landing-page/admin-bookings"  (click)="clickedOnAdminBookings()"><mat-icon aria-hidden="true">event_note</mat-icon><span>Bookings</span></a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse">
                          <a class="nav-link" [routerLink]="['transactions']" href="/landing-page/transactions" (click)="clickedOnTransactions()"><mat-icon aria-hidden="true">receipt_long</mat-icon><span>Transactions</span></a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse">
                          <a class="nav-link" [routerLink]="['reports']" href="/landing-page/reports" (click)="clickedOnReports()"><mat-icon aria-hidden="true">assessment</mat-icon><span>Reports</span></a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse">
                            <a class="nav-link" [routerLink]="['company-profile']" href="/landing-page/company-profile" (click)="clickedOnCompanyProfile()"><mat-icon aria-hidden="true">business</mat-icon><span>Company Profile</span></a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse">
                            <a class="nav-link" [routerLink]="['products']" href="landing-page/products" (click)="clickedOnProducts()"><mat-icon aria-hidden="true">category</mat-icon><span>Services</span></a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse" >
                            <a class="nav-link" [routerLink]="['venues']" href="landing-page/venues" (click)="clickedOnVenues()"><mat-icon aria-hidden="true">place</mat-icon><span>Venues</span></a>
                        </li>



                      </ul>
                      <ul class="nav navbar-nav descriptionHeader" *ngIf="roleId == 3">
                        <li class="nav-item" [routerLinkActive]="['active']" role="presentation" data-target="#navcol-1" data-toggle="collapse">
                          <a class="nav-link" [routerLink]="['transactions']" href="/landing-page/transactions" (click)="clickedOnTransactions()"><mat-icon aria-hidden="true">receipt_long</mat-icon><span>My Bookings</span></a>
                        </li>
                      </ul>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>


<router-outlet></router-outlet>
